export const searchVolopsPathByLocale = {
  en: '/en/volunteer',
  es: '/es/voluntariado',
  pt: '/pt/voluntariado',
} as const;

export const searchVolopsPaths = Object.values(searchVolopsPathByLocale);

export const searchVolopsPathsWithoutLang = Array.from(
  new Set(searchVolopsPaths.map((path) => path.substring(3))),
);
